module.exports = __webpack_public_path__ + "static/binary-2-ab7d55a9c301578a02d4995ef3ff681e.png";